import React from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "../ui/Button";




const Whystand = () => {
  const { t,i18n } = useTranslation("team"); // Hook to use translations
  const isRussian = i18n.language === "ru"; // Check if the language is Russian


  return (
    <div className="container-class">
      <div className="p-5 md:p-[100px] space-y-10">
        <h1 className="web-heading-section">{t("why_we_stand_out_title")}</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
            <div className="max-w-[239px]">

              <h1 className="title-xl tracking-tight">{t("industry_expertise")}</h1>
              <p className="body-medium text-[#EEEEEE99] tracking-[1px] mt-4">
                {t("industry_expertise_description")}
              </p>
            </div>
          </div>
          <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3 min-h-[220px]">
            <div className="max-w-[224px]">


              <h1 className="title-xl tracking-tight">
                {t("customer_first_approach")}
              </h1>
              <ul className="body-medium text-[#EEEEEE99] list-disc pl-6 mt-4 tracking-[1px]">
                <li>
                  {t("customer_first_approach_description")}
                </li>
              </ul>
            </div>
          </div>
          <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
            <div className="max-w-[240px]">

              <h1 className="title-xl tracking-tight">{t("passion_for_innovation")}</h1>
              <ul className="body-medium text-[#EEEEEE99] list-disc pl-6 mt-4 tracking-[1px]">
                <li>
                  {t("passion_for_innovation_description")}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="p-5 sm:p-[100px] flex flex-col justify-center items-center gap-5 text-center ellipsebg">

        <div className='max-w-[818px] flex flex-col justify-center items-center text-center gap-5'>
          <h1 className="web-heading-section px-12">
            {t("join_team")}
          </h1>
          <p className={`body-large-30 text-[#F0F0F0B2] ${isRussian ? 'lang-ru-contact-desc' : ''}`}>

            {t("join_team_description")}
          </p>
          <CustomButton>{t("send_resume")}</CustomButton>

          <h2 className="title-xl-2">{t("spontaneous_applications")}</h2>

          <p className={`body-large-30 text-[#F0F0F0B2] ${isRussian ? 'lang-ru-contact-desc' : ''}`}>

            {t("spontaneous_applications_description")}
          </p>

        </div>

      </div>
    </div>
  );
};

export default Whystand;
